import { gql, useQuery } from '@apollo/client';
import { Box, Container, Counter, Flex, Icon } from '@energiebespaarders/symbols';
import { Medium } from '@energiebespaarders/symbols/helpers';
import { ThumbsUp, Users } from '@energiebespaarders/symbols/icons/solid';
import React from 'react';
import 'slick-carousel/slick/slick.css';
import { GET_KLANTENVERTELLEN_REVIEWS } from '~/components/KlantenVertellenWidget';
import { useIsInitializing } from '~/hooks/useIsInitializing';
import theme from '~/styles/theme';
import type { amountBespaarchecks } from '~/types/generated/amountBespaarchecks';
import type { getKlantenVertellenScore } from '~/types/generated/getKlantenVertellenScore';
import type { PartnerKey } from '~/utils/constants';
import delimit from '~/utils/delimit';

export const BESPAARCHECKS = gql`
  query amountBespaarchecks {
    amountBespaarchecks
  }
`;

interface TrusterProps {
  singlePartner?: PartnerKey;
}

const Truster: React.FC<TrusterProps> = () => {
  const { isInitializing } = useIsInitializing();
  const { data, error } = useQuery<amountBespaarchecks>(BESPAARCHECKS, {
    fetchPolicy: 'cache-first',
    skip: isInitializing,
  });
  const { data: reviewData } = useQuery<getKlantenVertellenScore>(GET_KLANTENVERTELLEN_REVIEWS, {
    fetchPolicy: 'cache-first',
    skip: isInitializing,
  });

  const reviewScore = reviewData?.getKlantenVertellenScore?.last12MonthAverageRating ?? 8.5;

  return (
    <Flex style={{ background: theme.colors.greenSlate }}>
      <Container py={2} textAlign="center">
        <Flex flexWrap="wrap" alignItems="center" justifyContent="center" mx={[0, 0, 0, 0, -2]}>
          <Box width={[1, 1, 1 / 2]} px={2} pt={1}>
            <p>
              <Icon icon={Users} solid fill="green" mr={1} />{' '}
              {error ? (
                '70.000+'
              ) : (
                <Counter
                  value={data?.amountBespaarchecks ?? 70000}
                  duration={1000}
                  formatValue={(n: number) => delimit(Math.round(n), 0)}
                  className="bold"
                />
              )}{' '}
              mensen gingen je voor
            </p>
          </Box>
          <Box width={[1, 1, 1 / 2]} px={1} pt={1}>
            <p>
              <Icon icon={ThumbsUp} solid fill="green" mr={1} />
              Onze klanten geven ons gemiddeld een{' '}
              <Medium>
                <Counter
                  value={reviewScore}
                  duration={1000}
                  formatValue={(n: number) => delimit(n, 1)}
                />
              </Medium>
            </p>
          </Box>
        </Flex>
      </Container>
    </Flex>
  );
};

export default Truster;
